import { getIn } from "formik";
import FormControl from "@ds/components/FormControl";
import InputBase from "@ds/components/InputBase";
import { TFieldTextArea } from "./type";

const FieldTextArea: React.FC<TFieldTextArea> = ({
  label,
  name,
  id,
  type,
  value,
  hint,
  optional,
  placeholder,
  field,
  form,
  maxlength,
  info,
  FormControlProps,
  ...inputBaseProps
}) => {
  const { touched, errors } = form;
  const isError = getIn(touched, field.name) && getIn(errors, field.name);
  return (
    <FormControl
      label={label}
      hint={hint}
      error={isError}
      id={id}
      optional={optional}
      field={field}
      info={info}
      maxlength={maxlength}
      {...FormControlProps}
    >
      <InputBase
        minRows={4}
        multiline
        name={name}
        placeholder={placeholder}
        type={type}
        value={value}
        sx={{
          height: null,
          minHeight: 52
        }}
        inputProps={{
          maxLength: maxlength
        }}
        {...field}
        {...inputBaseProps}
      />
    </FormControl>
  );
};

export default FieldTextArea;
